<template>
    <section class="money-strategy">
        <div @click="handleNavigate('/knowledge-show')"></div>
        <div @click="handleNavigate(`/money`)"></div>
    </section>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'MoneyStrategy',
        methods: {
            handleNavigate(url) {
                if(url.indexOf('http') !== -1) {
                    window.location.href = url
                } else {
                    this.$router.push(url)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../style/main';

    .money-strategy {
        position: relative;
        width: 100%;
        height: rem(1334);
        background: {
            image: url('../assets/images/money-strategy-bg.png');
            size: cover;
            position: center rem(-65);
        }

        & > div {
            &:first-child {
                transform: translateX(-50%);
                position: absolute;
                top: rem(940);
                left: 50%;
                width: rem(240);
                height: rem(60);
            }

            &:last-child {
                transform: translateX(-50%);
                position: absolute;
                top: rem(1080);
                left: 50%;
                width: rem(658);
                height: rem(90);
            }
        }
    }
</style>
